<template>
  <div class="card">
    <div class="card-body">
      <div>
        <div class="d-flex flex-row justify-content-between">

          <div :class="spacing">
            <p>Not activated bonus points</p>
            <h3 class="not-active text-primary">{{ notActivePoints }} PT</h3>
            <div class="mt-1 text-muted">
              (will be activated after order is shipped)
            </div>
            <div class="mt-2 text-muted">
              You have {{ activePoints }} reward points which you can redeem for the $1.00 USD discount on future orders.
              {{ level?.rewards_multiplier }} point = $0.01 USD
            </div>
          </div>

          <div :class="spacing">
            <p>Reward points level:</p>
            <div class="text-muted">
              {{ level?.name }}
            </div>
          </div>

          <div :class="spacing">
            <p>Loyalty program duration:</p>
            <!-- todo change it later to real value -->
            <div class="text-muted">{{ joinDate }} - {{ nowDate }}</div>
          </div>
        </div>
      </div>
      <hr>
      <div>
        <div class="d-flex flex-row">
          <div class="mr-5">
            <p>Shipped orders total:</p>
            <div class="text-muted">
              ${{ currencyFormat(totalShippedOrders) }} USD
            </div>
          </div>
          <div>
            <p>Pending orders total:</p>
            <div class="text-muted">
              ${{ currencyFormat(totalNotShippedOrders) }} USD
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { currencyFormat} from "@core/helpers/configHelper";

export default {
  name: "LevelData",
  props: ['notActivePoints', 'activePoints', 'level', 'totalShippedOrders', 'totalNotShippedOrders', 'joinDate', 'nowDate', 'source'],
  computed : {
    spacing() {
      if (this.source == 'Admin') {
        return "col-md-4"
      }
      return "col-md-6"
    }
  },
  data() {
    return  {
      currencyFormat
    }
  }
}
</script>

<style scoped>
.not-active {
  font-size: 20px;
  //color: #00B9E8;
}
</style>
